import React, { FC, useCallback } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { PostalCode } from '../postal-code/postal-code'
import { useDispatch } from 'react-redux'
import { addAnswer } from '../../state'
import { Steps } from '../../state/interfaces'
import { setCookie } from '../../scenarios/storage'

export interface InputPostalCodeProps {
  name: string
}

export const InputPostalCode: FC<InputPostalCodeProps> = ({ name }) => {
  const dispatch = useDispatch()

  const onSubmit = useCallback(
    (postalCode: string) => {
      dispatch(addAnswer({ stepId: Steps.POSTAL_CODE_INTERNET, answerIds: [postalCode] }))
      setCookie('internetSearchPostalcode', postalCode)
    },
    [dispatch],
  )

  return (
    <Flex alignItems={'center'}>
      <Box mt={6}>
        <PostalCode onSubmit={onSubmit} name={name} />
      </Box>
    </Flex>
  )
}
